// `/market/packs/$packId` — one pack. The parent owns the build-master gate;
// the lazy child enables its query only from the server capability DTO.
//
// A draft pack, or one belonging to somebody else's account, answers from the
// gateway byte-for-byte like an id that names nothing. This route therefore
// cannot tell the two apart either, which is the point.
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/market/packs/$packId')({});
